import { render, staticRenderFns } from "./document-row.vue?vue&type=template&id=08f04554"
import script from "./document-row.vue?vue&type=script&lang=js"
export * from "./document-row.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports